import { CreateLiveDto } from '@shared/models/live';
import { InvitedPeopleDto } from '@shared/models/calendar';
import { LiveType } from '@shared/enums/live';
import { RoleEnum } from '@shared/enums/user';

export interface CreateLiveFormValue {
  title: string | null;
  code: string;
  description: string;
  studyType: string;
  physician: string;
  equipmentId: string | null;
  organizerEmail: string | null;
  liveId: number | null;
}

export interface CreateLiveContext {
  organizationId: number | undefined;
  medinboxId: string | null;
  moderatorInvites: string[];
  contactInvites: string[];
  fallbackTitle: string;
}

/** Contacts are sent without a role, unlike moderators. */
export function buildCreateLiveDto(form: CreateLiveFormValue, context: CreateLiveContext): CreateLiveDto {
  const { medinboxId } = context;
  const invitedPeoples: InvitedPeopleDto[] = [
    ...context.moderatorInvites.map((email) => ({ email, role: RoleEnum.Moderator })),
    ...context.contactInvites.map((email) => ({ email })),
  ];

  return {
    organizationId: context.organizationId as number,
    code: form.code.trim().toUpperCase(),
    title: form.title ?? context.fallbackTitle,
    studyType: form.studyType,
    liveId: form.liveId,
    physician: form.physician,
    isReservedAlias: false,
    description: form.description,
    equipmentId: form.equipmentId ?? medinboxId ?? null,
    liveType: LiveType.Public,
    invitedPeoples,
    organizerEmail: form.organizerEmail ?? (medinboxId ? medinboxId + '@medinbox.com' : null),
  } as CreateLiveDto;
}
